import React, { useEffect } from 'react';
import Header from './components/Header';
import MobileNav from './components/MobileNav';
import SideBar from './components/SideBar';
import { Link } from 'react-router-dom';
import ProductGif from '../../assets/gif/product.gif'
import BagGif from '../../assets/gif/bag.gif'
// import PaidGif from '../../assets/gif/paid.gif'
import { connect } from 'react-redux';
import { artisanProductListAction } from '../../redux/actions/ArtisanAction';
import { getArtisanAllOrders } from '../../redux/actions/OrderActions';
import LoaderSM from '../../components/LoaderSM';


const ArtisanDashboard = ({ artisanProductListAction, artisanProductList, artisanOrderList, getArtisanAllOrders }) => {

    const { loading:artisanLoading, products } = artisanProductList;
    const { loading:artisanOrderLoading, artisanOrderLists } = artisanOrderList;

    useEffect(() => {
      
        artisanProductListAction()
        getArtisanAllOrders()
    
    }, [artisanProductListAction, getArtisanAllOrders])
    

    return (
        <div className='bg-gray-100 min-h-screen'>
            <SideBar />
            <MobileNav />
            <Header />
            <div className='md:ml-72 px-4'>
                <div className='mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 '>
                    
                    <Link to='/artisan/productList' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(90deg, hsla(186, 33%, 94%, 1) 0%, hsla(216, 41%, 79%, 1) 100%)'  }}>
                            <img src={ProductGif} alt='product' className='w-14 h-14' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Products</p>
                            {artisanLoading ? <LoaderSM /> : <div className='mt-1 text-xl font-medium'>+{products && products.length}</div>}
                        </div>
                    </Link>
                    <Link to='/artisan/orderList' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(90deg, hsla(11, 82%, 87%, 1) 0%, hsla(299, 85%, 90%, 1) 100%)'  }}>
                            <img src={BagGif} alt='user' className='w-14 h-14' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Orders</p>
                            {artisanOrderLoading ? <LoaderSM /> : <div className='mt-1 text-xl font-medium'>+{artisanOrderLists && artisanOrderLists.length}</div>}
                        </div>
                    </Link>
                    {/* <Link to='/artisan/orderList' className='flex bg-white items-center shadow p-4 rounded hover:shadow-xl'>
                        <div className='p-4 rounded mr-6' style={{ background: 'linear-gradient(90deg, hsla(233, 100%, 90%, 1) 0%, hsla(0, 0%, 89%, 1) 100%)'  }}>
                            <img src={PaidGif} alt='user' className='w-14 h-14' />
                        </div>
                        <div>
                            <p className='text-xl font-semibold mont-font'>Order Success</p>
                            <div className='mt-1 text-md font-medium'>+67</div>
                        </div>
                    </Link> */}
                </div>
            </div>
        </div>
    )
}


const mapStateToProps = (state) => ({
    artisanProductList: state.artisanProductList,
    artisanOrderList: state.artisanOrderList
})

export default connect(mapStateToProps, { artisanProductListAction, getArtisanAllOrders  })(ArtisanDashboard);